import React from "react";
import "./index.css";

// Import your images
import img1 from "./images/art1.png";
import img2 from "./images/art2.png";
import img3 from "./images/art3.png";
import img4 from "./images/art4.png";

export default function SeriesPage() {
  const images = [img1, img2, img3, img4];

  return (
    <div className="series-page">
      <div className="series-container">
        {images.map((src, index) => (
          <div key={index} className="series-item">
            <img src={src} alt={`Series ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
}
